import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import LoiIch from './components/LoiIch';
import CachChoi from './components/CachChoi';
import BangChungXaHoi from './components/BangChungXaHoi';
import TrungBayGiaiThuong from './components/TrungBayGiaiThuong';
import TinhTrangCapThiet from './components/TinhTrangCapThiet';
import CauHoiThuongGap from './components/CauHoiThuongGap';
import KeuGoiHanhDongCuoi from './components/KeuGoiHanhDongCuoi';
import ChanTrang from './components/ChanTrang';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <>
      <Helmet>
        <html lang="vi" />
        <title>Game May Mắn - Quay Số Trúng 10 Triệu Đồng | Chơi Miễn Phí Mỗi Ngày</title>
        <meta name="description" content="Game quay số may mắn trúng tiền thật. Đã trao 15 tỷ đồng cho 250,000+ người chơi. Quay số miễn phí mỗi ngày, trúng ngay từ 100k đến 10 triệu đồng. Rút tiền tức thì!" />
        <meta name="keywords" content="game may mắn, quay số may mắn, quay số trúng tiền, game trúng thưởng, quay số miễn phí, trúng 10 triệu, game may mắn uy tín, quay số online" />
        <meta property="og:title" content="Game May Mắn - Quay Số Trúng 10 Triệu Đồng" />
        <meta property="og:description" content="Quay số may mắn miễn phí, trúng ngay tiền thật. Đã trao 15 tỷ đồng giải thưởng. Tỷ lệ trúng 12.5%, rút tiền trong 5 phút!" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://gamemayman.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Game May Mắn - Quay Số Trúng 10 Triệu" />
        <meta name="twitter:description" content="Quay số may mắn miễn phí, trúng ngay tiền thật. Rút tiền tức thì!" />
        <link rel="canonical" href="https://gamemayman.com" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Game May Mắn",
            "description": "Game quay số may mắn trúng tiền thật. Đã trao 15 tỷ đồng cho 250,000+ người chơi. Quay số miễn phí mỗi ngày.",
            "url": "https://gamemayman.com",
            "applicationCategory": "Game",
            "operatingSystem": "Web",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "VND"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "250000"
            }
          })}
        </script>
      </Helmet>
      
      <div className="App">
        <Header />
        <LoiIch />
        <CachChoi />
        <BangChungXaHoi />
        <TrungBayGiaiThuong />
        <TinhTrangCapThiet />
        <CauHoiThuongGap />
        <KeuGoiHanhDongCuoi />
        <ChanTrang />
        <ScrollToTop />
      </div>
    </>
  );
}

export default App;

